var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass: "treatments-list",
      attrs: {
        "aria-label": _vm.tc(
          "spaSoft.step1.treatmentCards.ariaLabelAvailableTreatments",
          { categoryTitle: _vm.selectedCategory }
        ),
      },
    },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "li",
        { key: item.Id, staticClass: "treatments-list__item" },
        [
          _c("TreatmentsCard", {
            attrs: { treatment: item, index: index },
            on: {
              "treatment-selected": function ($event) {
                return _vm.$emit("treatment-selected")
              },
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }